import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Stack, Typography } from '@mui/material';

import InputLabel from '../../../../components/v2/InputLabel';
import { Field } from './style';

const ChipMultiSelect = ({
  label,
  options,
  selected,
  onToggle,
  helperText,
}) => (
  <Field>
    <InputLabel>{label}</InputLabel>
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
      {options.map((option) => {
        const active = selected.includes(option.value);
        return (
          <Chip
            key={option.value}
            label={option.label}
            clickable
            color={active ? 'primary' : 'default'}
            variant={active ? 'filled' : 'outlined'}
            onClick={() => onToggle(option.value)}
          />
        );
      })}
    </Stack>
    {helperText && (
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
        {helperText}
      </Typography>
    )}
  </Field>
);

ChipMultiSelect.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggle: PropTypes.func.isRequired,
  helperText: PropTypes.string,
};

ChipMultiSelect.defaultProps = {
  helperText: '',
};

export default ChipMultiSelect;
